<template>
  <vs-popup
    :active="isAddScore"
    title="Record scores"
    v-on:update:active="UpdateActive"
    size="large"
  >
    <feather-icon
      icon="AwardIcon"
      class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
      svgClasses="h-8 w-8"
      style="float: left; margin-right: 10px"
    ></feather-icon>
    <h3 v-if="this.fromPerson && this.currentToScore && this.skill">
      {{ this.fromPerson.FirstName }}
      rewards
      {{ this.currentToScore.FirstName ? this.currentToScore.FirstName : this.currentToScore.Name}} on {{ this.skill.SkillName }} skill
    </h3>
    <h3></h3>
    <div style="clear: both"></div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/1">
        <UserDropdownSelector v-model="toScorePerson">
        </UserDropdownSelector>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/1">
        Score:<br />
        <vs-input class="w-full" v-model="score" />
        <br />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/1">
        <vs-textarea label="Add Comment" class="mb-2" v-model="comment" />
        <vs-button size="small" style="float: right" @click="saveScore"
          >Save score</vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import SkillsService from "@/skills/skillsService.js";
import UserDropdownSelector from "@/views/components/extra-components/users/UserDropdownSelector.vue";

export default {
  data() {
    return {
      comment: "",
      score: 0,
      toScorePerson: null,
    };
  },
  methods: {
    saveScore() {
      var instance = this;
      var userToScore = this.currentToScore;

      SkillsService.logScore(
        null,
        this.skill.Id,
        this.fromPerson.Id,
        userToScore.Id,
        this.comment,
        this.score
      ).then(function () {
        instance.$vs.notify({
          time: 8000,
          title: "Success",
          text: "Points added.",
          color: "success",
          iconPack: "feather",
          icon: "icon-success-circle",
        });

        var newScores = instance.skill.MyScores * 1 + instance.score * 1;

        instance.$set(instance.skill, "MyScores", newScores);
        instance.$set(instance, "score", 0);
        instance.$set(instance, "comment", "");
        instance.$set(instance, "isAddScoreCalculated", false);

        window.setTimeout(function(){ window.location.reload()}, 2000);
      });
    },
  },
  props: [
    "isAddScore",
    "skill",
    "toPerson",
    "fromPerson",
    "accountId",
    "UpdateActive",
  ],
  computed: {
    isAddScoreCalculated: {
      get: function () {
        return this.isAddScore;
      },
      set: function (value) {
        this.$emit("isAddScore", value);
        this.UpdateActive(value);
      },
    },
    currentToScore: {
      get: function(){
        if (this.toScorePerson != null)
          return this.toScorePerson;
        else
          return this.toPerson;
      }
    }
  },
  components: {
    UserDropdownSelector,
  },
};
</script>
